import React, {useEffect} from 'react';
import {Platform} from 'react-native';

export type ControlsListOptions =
  | 'nodownload'
  | 'nofullscreen'
  | 'noremoteplayback'
  | 'nopictureinpicture'
  | 'nofastforward'
  | 'noplaybackrate';

interface VideoProps {
  source: {uri: string};
  repeat?: boolean;
  controls: boolean;
  style?: React.CSSProperties;
  resizeMode?: 'cover' | 'contain';
  onError?: (event: React.SyntheticEvent<HTMLVideoElement, Event>) => void;
  onLoad?: (event: React.SyntheticEvent<HTMLVideoElement, Event>) => void;
  onLoadStart?: (event: React.SyntheticEvent<HTMLVideoElement, Event>) => void;
  paused?: boolean;
  controlsList?: ControlsListOptions[];
}

const Video = ({
  source,
  repeat = true,
  style,
  resizeMode,
  onError,
  onLoad,
  onLoadStart,
  paused,
  controls,
  controlsList = [],
}: VideoProps) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);

  // Ensure 'style' is a single object by merging array elements, if it's an array.
  style = Array.isArray(style) ? style.reduce((acc, val) => Object.assign(acc, val), {}) : style;

  useEffect(() => {
    if (paused) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }
  }, [paused]);

  useEffect(() => {
    if (Platform.OS === 'web' && videoRef.current) {
      // Explicitly disable Picture-in-Picture
      videoRef.current.disablePictureInPicture = controlsList.includes('nopictureinpicture')
        ? true
        : false;
    }
  });
  return (
    <video
      controls={controls}
      ref={videoRef}
      src={source.uri}
      style={{
        width: '100%',
        ...style,
        objectFit: resizeMode === 'cover' ? 'cover' : 'contain',
      }}
      controlsList={controlsList.join(' ')}
      loop={repeat}
      onError={onError}
      onLoadedData={onLoad}
      onLoadStart={onLoadStart}
      muted
    />
  );
};

export default Video;
